<template>
  <div class="layout-inner">
    <navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">
        <div v-if="index === 0">
          <terms-of-use></terms-of-use>
        </div>
        <div v-else>
          <privacy-policy></privacy-policy>
        </div>
        <div class="mt-4">
          <div style="margin-left: 10px;">
            <input type="checkbox" id="tnc_chkbox" v-model="status" value="true">
            <label for="tnc_chkbox" style="float: right; width: 95%;">I agree to the pragya systems <a href="javascript://" @click="index = 0">terms of use</a> and <a href="javascript://" @click="index = 1">privacy policy</a>.</label>
          </div>
        </div>
        <div class="text-center mt-3">
          <b-button @click="tnCAccepted" :disabled="!status">Continue</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { getItem } from '../../../storage'
  import TermsOfUse from './TermsOfUse'
  import PrivacyPolicy from './PrivacyPolicy'
  import Navbar from '../../misc/components/./Navbar'
  import { PACKAGE } from '../../../package_constants'

  export default {
    name: 'terms-and-conditions',
    props: ['userObj'],
    components: {
      Navbar,
      TermsOfUse,
      PrivacyPolicy
    },
    data: () => {
      return {
        index: 0,
        status: false
      }
    },
    mounted () {
      if (!this.userObj) {
        getItem('userobj').then(data => {
          this.userObj = data
        })
      }
      if (!this.userObj) {
        return this.$router.push({ name: 'login' })
      }
    },
    methods: {
      ...mapActions([
        'loadSaveUser',
        'loadInstitutionPackage'
      ]),
      showLoader () {
        this.$parent.$refs.loadingModal.show()
      },
      hideLoader () {
        this.$parent.$refs.loadingModal.hide()
      },
      tnCAccepted () {
        let token = this.userObj.password
        this.userObj.password = "*&^^&*"
        this.userObj.tnCAccepted = this.status
        this.loadSaveUser({uuid: this.userObj.uuid, user: this.userObj}).then(res => {
          let role = res.roles[0].role
          if ((role === 'Student') && this.isXprizeDataOptOutEnabled) {
            return this.$router.push({name: 'dataPrivacy', params: {userObj: this.userObj}})
          }
          return this.$router.push({name: 'dashboard'})
        })
      }
    },
    computed: {
      ...mapState({
        'enabledFeatures': state => state.dashboard.enabledFeatures
      }),
      isXprizeDataOptOutEnabled () {
        let xprizeDataOptOutFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_XPRIZE_DATA_OPT_OUT]
        if (xprizeDataOptOutFeature) {
          return xprizeDataOptOutFeature.enabled
        }
        return false
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/login/components/TermsAndConditions.vue